import React, { useEffect, useState } from "react";
import { tryFetch } from "../../Helpers/FetchAPI";
import EventDetails from "./EventDetails";
import TicketForm from "./TicketForm";
import TicketSelection from "./TicketSelection";
import CheckoutSummary from "./CheckoutSummary";
import ProceedCheckoutButton from "./CheckoutButton";
import "../../styles/GetTicket.scss";

const GetTicketPage = () => {
  const [eventData, setEventData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [quantity, setQuantity] = useState(1);
  const [selectedTicket, setSelectedTicket] = useState<any>(null);
  const [selectedDate, setSelectedDate] = useState<string>("");
  const [formData, setFormData] = useState<any>({});

  useEffect(() => {
    const fetchEvent = async () => {
      const response = await tryFetch({
        url: "/events/1c125082-5c19-4626-93f9-67f9631654ba",
        // url: "/events/c7d4cea1-01ef-45df-9a09-389afbbf205f",
        method: "GET",
      });

      if (response.is_success) {
        setEventData(response.data);
      }
      setLoading(false);
    };
    fetchEvent();
  }, []);

  if (loading) return <div className="page-loading">Loading event...</div>;
  if (!eventData) return <div className="no-event">Event not found.</div>;

  //     if (response.is_success && Array.isArray(response.data)) {
  //       const aplcEvent = response.data.find(
  //         (e: any) => e.id === "1c125082-5c19-4626-93f9-67f9631654ba"
  //       );
  //       setEventData(aplcEvent);
  //     }
  //     setLoading(false);
  //   };
  //   fetchEvent();
  // }, []);

  if (loading) return <div className="page-loading">Loading event...</div>;
  if (!eventData) return <div className="no-event">Event not found.</div>;

  return (
    <div className="get-ticket-container">
      <div className="ticket-page-grid">
        <EventDetails event={eventData} />

        <div className="ticket-sections">
          <TicketForm formData={formData} setFormData={setFormData} />
          <TicketSelection
            event={eventData}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate} 
            selectedTicket={selectedTicket}
            setSelectedTicket={setSelectedTicket}
            quantity={quantity}
            setQuantity={setQuantity}
          />

          <CheckoutSummary
            selectedTicket={selectedTicket}
            quantity={quantity}
          />
          <ProceedCheckoutButton
            formData={formData}
            selectedTicket={selectedTicket}
            quantity={quantity}
            selectedDate={selectedDate}
            allDates={eventData.all_dates || []}
          />
        </div>
      </div>
    </div>
  );
};

export default GetTicketPage;
